module.exports = __webpack_public_path__ + "img/logo2.41c652c7.png";